
import React from 'react';
import { Button } from '@/components/ui/button';
import NavigationButtons from './NavigationButtons';

interface QuizFooterProps {
  quizSubmitted: boolean;
  quizPassed: boolean;
  questions: any[];
  hasSelectedOptions: boolean;
  currentQuestionIndex: number;
  onPrevQuestion: () => void;
  onNextQuestion: () => void;
  onSubmit: () => void;
  onReset: () => void;
}

const QuizFooter: React.FC<QuizFooterProps> = ({
  quizSubmitted,
  quizPassed,
  questions,
  hasSelectedOptions,
  currentQuestionIndex,
  onPrevQuestion,
  onNextQuestion,
  onSubmit,
  onReset,
}) => {
  if (quizSubmitted) {
    // Show retry button only if quiz failed
    if (!quizPassed) {
      return (
        <Button className="w-full mt-4" onClick={onReset}>
          Opnieuw proberen
        </Button>
      );
    }
    return null;
  }

  // Check if user has answered at least one question in the entire quiz
  const hasAnsweredAnyQuestion = Object.keys(questions).length > 0 && hasSelectedOptions;

  return (
    <div className="mt-4">
      <NavigationButtons
        currentQuestionIndex={currentQuestionIndex}
        questionsLength={questions.length}
        hasSelectedOptions={hasSelectedOptions}
        onPrevQuestion={onPrevQuestion}
        onNextQuestion={onNextQuestion}
      />
      
      <Button 
        className="w-full mt-2" 
        onClick={onSubmit}
        disabled={!hasAnsweredAnyQuestion}
      >
        Quiz indienen
      </Button>
    </div>
  );
};

export default QuizFooter;
